export default __webpack_public_path__ + "static/open-graph-66dd96c4be0d374ee15b6e48c0c2499c.png";